import { MessageCircle, Mail } from "lucide-react";
import { useLanguage, waLink } from "@/i18n";
import ContactForm from "@/components/ContactForm";
import SectionHeader from "@/components/SectionHeader";
import { useSEO } from "@/hooks/useSEO";

export default function Contact() {
  const { t } = useLanguage();
  useSEO(`${t("contact_title")} — Flegrea Experience`, t("contact_sub"));

  return (
    <div className="py-16 lg:py-24" data-testid="contact-page">
      <div className="max-w-3xl mx-auto px-6">
        <SectionHeader overline="Flegrea Experience" title={t("contact_title")} sub={t("contact_sub")} />
        <div className="mt-12">
          <ContactForm />
        </div>
        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          <a href={waLink(t("wa_message") + " ")} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp"
            className="border border-stone2/60 p-6 flex items-center gap-4 hover:border-medblue transition-colors duration-300">
            <MessageCircle size={20} strokeWidth={1.25} className="text-medblue" />
            <div>
              <p className="text-sm font-medium text-ink">WhatsApp</p>
              <p className="text-xs text-ink/50">{t("ask_questions")}</p>
            </div>
          </a>
          <a href="mailto:info@flegreaexperience.com" data-testid="contact-email-link"
            className="border border-stone2/60 p-6 flex items-center gap-4 hover:border-medblue transition-colors duration-300">
            <Mail size={20} strokeWidth={1.25} className="text-medblue" />
            <div>
              <p className="text-sm font-medium text-ink">info@flegreaexperience.com</p>
              <p className="text-xs text-ink/50">Email</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
